import styled, { createGlobalStyle } from 'styled-components';
import { mediaQuery } from '../common/styles/styleUtil';

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const GlobalStyle = createGlobalStyle`
  .ant-modal {
    width: 100% !important;
    height: 100%;
    padding: 0;
    top: 0;
    @media (${mediaQuery.mobile}) {
      max-width: 100%;
    }

    .ant-modal-content {
      height: 100%;

      .ant-modal-body {
        height: 100%;
      }
    }
  }

  .ant-modal.share-qr-popup {
    top: 196px;
    @media (${mediaQuery.mobile}) {
      top: 0;
      padding: 0;
      margin: 0;
    }

    .ant-modal-body {
      padding: 32px 24px 94px 24px;
    }

    .ant-modal-close {
      right: 24px;
      top: 24px;
    }

    .ant-modal-content {
      width: 400px;
      height: 434px;
      margin: 0 auto;
      border-radius: 0;
      @media (${mediaQuery.mobile}) {
        width: 100%;
        height: 100vh;
     }
    }

    .share-qr-react {
      width: 170px;
      height: 170px;
    }

    .ant-modal-close-x {
      font-size: 24px;
      width: initial;
      height: initial;
      line-height: initial;
      font-weight: normal;
      color: #697684;
    }
  }

  // Use this non-standard workaround to fix a Firefox bug
  // More info: https://bugzilla.mozilla.org/show_bug.cgi?id=1472637
  img:-moz-loading {
    color: transparent;
  }
`;
